// ==============================|| THEME CONSTANT ||============================== //

export const APP_DEFAULT_PATH = '/dashboard/default';
export const DRAWER_WIDTH = 260;
export const MINI_DRAWER_WIDTH = 60;

// ==============================|| WEB3 RECEIVER CONFIG ||============================== //
// THIS IS THE WALLET THAT WILL RECEIVE ALL DEPOSITS AND PLAN PURCHASES
export const RECEIVER_WALLET_ADDRESS = '0xE3D369D83BE559D43F2c280FE1E2873DC0C9057C'; // CHANGE THIS TO YOUR WALLET ADDRESS

const config = {
  fontFamily: `'Public Sans', sans-serif`,
  presetColor: 'default',
  mode: 'dark'
};

export default config;
